import {store} from 'Store/store.index';
import React from 'react'
import intl from 'react-intl-universal';
import { observer, inject } from 'mobx-react'
import {DialogContainer, DLG_TARGETS} from '../EditorDialogsContainer'
import { convertController, fileController, preferenceFullScreenController } from "../Controllers/index";
import {EDIT_TEXT, EDIT_TEXT_FONT, EDIT_TEXT_SIZE,EDIT_APPEND_ALL_WEB_LINKS,EDIT_VIEW_WEB_LINKS, EDIT_ADD_ARTICLE} from '../ui/constants/edit.constants'
import EditorContainer from '../EditorContainer';

  type Props = {
    containerCallbacks:any;
  };
  type State = {
    messageDlgCfg:any;
  };
  
@inject('appStore', 'driveStore', 'privateDriveStore', 'taskStore', 'userStore', 'collaborationStore')
@observer
export default class EditTab extends React.Component<Props, State> {

  pdfui: any;
  uiMgr:EditorContainer;
  urlsArrAppendWebLinks:any;
  convertErrorByAppendWebLinks = false;
  state: State ={ messageDlgCfg:null};

    constructor(props) {
        super(props);
        this.uiMgr = props.containerCallbacks
    }

    componentDidMount(): void {
      const actions = {
        [EDIT_APPEND_ALL_WEB_LINKS]: () => {
          fileController.getUrlLinksObj().then((urls)=>{
            if(urls.length==0){
              this.uiMgr.showMsgLayer({id:"Error.noLinks"});
            }else{
              this.onShowAppendWebLinksDlg(urls);
            }
          })
         },
        [EDIT_VIEW_WEB_LINKS]: () => {
          fileController.getUrlLinksObj().then((urls)=>{
            if(urls.length==0){
              this.uiMgr.showMsgLayer({id:"Error.noLinks"});
            }else{
              this.onShowEditViewWebLinksDlg(urls);
            }
          })
         }
      };
      const {setupViewerActionCallback} = this.uiMgr;
      Object.keys(actions).map(name => {
        setupViewerActionCallback(name, actions[name]);
      })
    }

  updateUrlsAppendWebLinks = (url)=>{
    this.urlsArrAppendWebLinks=url;
    this.uiMgr.setState({
      messageDlgCfg:{
        target: DLG_TARGETS.AppendWebLinks,
        toCache: true,
        config:{
          urlList:url,
          onStop: this.onCloseByAppendWebLinksDlg
        }
      }
    })
  }
  
  //失败的统一处理逻辑
  errorCallbackAppendWebLinks = (urlInfo,res) => {
      this.convertErrorByAppendWebLinks=true
    urlInfo.Status=intl.formatMessage({ id: 'AppendWebLinks.Error' })
    this.updateUrlsAppendWebLinks(this.urlsArrAppendWebLinks);
    res();
  }

  //统一对link转换插入当前文档后操作
  appendUrlsOnCurrentPDFToSuccess = ()=>{
    store.taskStore.setHasTask(false);
    if(this.convertErrorByAppendWebLinks){
      this.convertErrorByAppendWebLinks=false;
      //进行stop按钮改为ok按钮
      this.uiMgr.setState({
        messageDlgCfg:{
          target: DLG_TARGETS.AppendWebLinks,
          toCache: true,
          config:{
            isOk:true,
            urlList:this.urlsArrAppendWebLinks,
            onStop: this.onCloseByAppendWebLinksDlg
          }
        }
      })
      return
    }
    this.uiMgr.setState({
      messageDlgCfg:{
        target:'',
        config:{
          urlList:this.urlsArrAppendWebLinks,
          onStop: this.onCloseByAppendWebLinksDlg
        }
      }
    })
  }

  onShowAppendWebLinksDlg = (urlList)=>{
    this.urlsArrAppendWebLinks=urlList;
    this.uiMgr.setState({
      messageDlgCfg:{
        target: DLG_TARGETS.AppendWebLinks,
        toCache: true,
        config:{
          urlList,
          onStop: this.onCloseByAppendWebLinksDlg
        }
      }
    },()=>{
      convertController.appendUrlsOnCurrentPDF(
        "",
        this.urlsArrAppendWebLinks,
        (urlsArr)=>{
          this.updateUrlsAppendWebLinks(urlsArr)
        },
        (urlInfo,res)=>{
          this.errorCallbackAppendWebLinks(urlInfo,res)
        },
        ()=>{
          this.appendUrlsOnCurrentPDFToSuccess()
        }
      )
    })
  }

  onShowEditViewWebLinksDlg = (urlList)=>{
    this.uiMgr.setState({
      messageDlgCfg:{
        target: DLG_TARGETS.EditViewWebLinks,
        toCache: true,
        config:{
          editURL:urlList,
          onCancel: this.onCloseByEditViewWebLinksDlg,
          downloadUrlByEditViewWebLinks:this.downloadUrlByEditViewWebLinks
        }
      }
    })
  }

  downloadUrlByEditViewWebLinks = (urls,setting)=>{
    this.urlsArrAppendWebLinks=urls;
    this.uiMgr.setState({
      messageDlgCfg:{
        target:""
      }
    },()=>{
      convertController.appendUrlsOnCurrentPDF(
        setting,
        this.urlsArrAppendWebLinks,
        (urlsArr)=>{
          this.updateUrlsAppendWebLinks(urlsArr)
        },
        (urlInfo,res)=>{
          this.errorCallbackAppendWebLinks(urlInfo,res)
        },
        ()=>{
          this.appendUrlsOnCurrentPDFToSuccess()
        }
      )
    })
  }

  onCloseByAppendWebLinksDlg = (isOk)=>{
    this.convertErrorByAppendWebLinks=false,
    this.uiMgr.setState({
      messageDlgCfg:{
        target:''
      }
    })
    //点击按钮为ok时候只是关闭弹窗操作
    if(isOk) return;
     //点击stop后进行关闭任务操作
    store.taskStore.doCancelCurrentTask();

  }

  onCloseByEditViewWebLinksDlg = ()=>{
    this.uiMgr.setState({
      messageDlgCfg:{
        target:''
      }
    })
  }
    render() 
    {
      return (
      <React.Fragment>
      </React.Fragment>
      )
    }
  
}
